function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  className: "imageRatio_4-3_svg__Thumbnail_Pro imageRatio_4-3_svg__Gallery imageRatio_4-3_svg__layout_Image imageRatio_4-3_svg__Ratio_4-3"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#80B1FF",
  d: "M26 12H12a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2V14a2 2 0 00-2-2z",
  className: "imageRatio_4-3_svg__illus-clr-1"
}));

function SvgImageRatio43(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='38' height='38' fill='none' viewBox='0 0 38 38'%3E %3Cg class='Thumbnail_Pro Gallery layout_Image Ratio_4-3'%3E %3Cpath fill='%2380B1FF' d='M26 12H12a2 2 0 00-2 2v10a2 2 0 002 2h14a2 2 0 002-2V14a2 2 0 00-2-2z' class='illus-clr-1'/%3E %3C/g%3E %3C/svg%3E";
export { SvgImageRatio43 as ReactComponent };